import React from "react";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import { FALLBACK_EMAIL } from "Source/components/project/Config/Config";
import { copyToClipboard } from "Source/util/navigator";

class AccountEmail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false,
        }
    }

    handleCopy = () => {
        const { email } = this.props;

        copyToClipboard(email);
    }

    handleMouseEnter = () => {
        this.setState({isHovered: true});
    }
    
    handleMouseLeave = () => {
        this.setState({isHovered: false});
    }

    render() {
        const { isEdit, email } = this.props;
        const { isHovered } = this.state;

        return <div class="emailContainer">
            <p>{ email }</p>
            {!isEdit && email !== FALLBACK_EMAIL &&
                <React.Fragment>
                    <a onClick={this.handleCopy}><i class="material-icons">content_copy</i></a>
                </React.Fragment>
            }

            {isEdit && email !== FALLBACK_EMAIL &&
                <React.Fragment>
                    <i class={`${isHovered ? "material-icons" : "material-icons-outlined" }`} 
                          data-tooltip-id="account-email-info"
                        onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}
                    >
                            info
                    </i>
                    <Tooltip id={`account-email-info`}  place="right" effect="solid">To change this setting, please contact your admininstrator.</Tooltip>
                </React.Fragment>
            
            }
        </div>
    }
}

export default AccountEmail;